import { render, staticRenderFns } from "./DeleteEmployee.vue?vue&type=template&id=65e208d4&scoped=true"
import script from "./DeleteEmployee.vue?vue&type=script&lang=js"
export * from "./DeleteEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e208d4",
  null
  
)

export default component.exports